import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-first-access-serasa-alerta',
  templateUrl: './modal-first-access-serasa-alerta.component.html',
  styleUrls: ['./modal-first-access-serasa-alerta.component.scss']
})
export class ModalFirstAccessSerasaAlertaComponent { }
